<app-tariff-overview
  [tariffCalculatedResponse]="{
    amount: 1200,
    tariffId: 'TARF-TOS-MAXVD60G-1GCXVGM7JE',
    slabIndex: 0,
    ruleSetCalculationResponses: [{
        ruleSetIdx: 0,
        rowIdx: 0,
        colIdx: 1,
        amount: 1200
        }]
    }"
></app-tariff-overview>

